export default function isAdmin(user: any) {
  if (!user || !user.roles) {
    return false;
  }
  return user.roles.some((role: any) => role.role.role === 'admin');
}
